import FileInput from './FileInput.vue';

export default FileInput;
